import { DEAD_ADDRESS, TRANSFER_TOPIC, VITALIK } from "../../integration.js";
import { CORE_PINNED_BLOCK_HASHES, CORE_PINNED_BLOCK_HEIGHTS, CORE_PINNED_TRANSACTION_HASHES } from "../pinned.js";
import { ERC20_BALANCE_OF_REFERENCE_CALLDATA } from "../fixture-inputs.js";
export const BERACHAIN_TEST_CONFIG = {
    balance: { address: VITALIK },
    blockQuery: {
        block: CORE_PINNED_BLOCK_HEIGHTS.berachain,
        fixture: "getBlockByNumberBerachain",
    },
    balanceQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.berachain,
        fixture: "getBalanceBerachain",
    },
    tokenBalanceQuery: {
        address: VITALIK,
        // WBERA — standard wrapped-native contract, live from genesis.
        token: "0x6969696969696969696969696969696969696969",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.berachain,
        fixture: "getTokenBalanceBerachain",
    },
    blockHashQuery: {
        hash: CORE_PINNED_BLOCK_HASHES.berachain,
        fixture: "getBlockByHashBerachain",
    },
    blockTransactionsQuery: {
        blockNumber: CORE_PINNED_BLOCK_HEIGHTS.berachain,
        fixture: "getBlockTransactionsBerachain",
    },
    transfersQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.berachain,
        fixture: "getTransfersBerachain",
    },
    simulateCallQuery: {
        to: "0x6969696969696969696969696969696969696969",
        data: ERC20_BALANCE_OF_REFERENCE_CALLDATA,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.berachain,
        fixture: "simulateCallBerachain",
    },
    traceTransactionQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.berachain,
        fixture: "traceTransactionBerachain",
    },
    tokenMetadataQuery: {
        address: "0x6969696969696969696969696969696969696969",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.berachain,
        fixture: "getTokenMetadataBerachain",
    },
    tokenAllowanceQuery: {
        token: "0x6969696969696969696969696969696969696969",
        owner: VITALIK,
        spender: DEAD_ADDRESS,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.berachain,
        fixture: "getTokenAllowanceBerachain",
    },
    portfolioQuery: {
        address: VITALIK,
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.berachain,
    },
    receiptQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.berachain,
        fixture: "getReceiptBerachain",
    },
    transactionByHashQuery: {
        hash: CORE_PINNED_TRANSACTION_HASHES.berachain,
        fixture: "getTransactionByHashBerachain",
    },
    estimateGasQuery: {
        to: VITALIK,
        fixture: "estimateGasBerachain",
    },
    codeQuery: {
        address: "0x6969696969696969696969696969696969696969",
        blockHeight: CORE_PINNED_BLOCK_HEIGHTS.berachain,
        fixture: "getCodeBerachain",
    },
    logsQuery: {
        address: "0x6969696969696969696969696969696969696969",
        topic0: TRANSFER_TOPIC,
        fromBlock: String(CORE_PINNED_BLOCK_HEIGHTS.berachain),
        toBlock: String(CORE_PINNED_BLOCK_HEIGHTS.berachain),
        fixture: "getLogsBerachain",
    },
};
